import { gateway } from "../../../gateway";

export const deleteWorkforce = async (workforceId: string) => {
    try {
        const token = sessionStorage.getItem("token");
        const response = await gateway.delete(`/workforce/${workforceId}`, {
            headers: { Authorization: token },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting workforce:", error);
        throw error;
    }
};